module.exports = __webpack_public_path__ + "img/4F4C45_A7AEAA_7A8575_9D97A2-256px.813d05d4.png";